// extracted by mini-css-extract-plugin
export var numpadContainer = "_nx-1";
export var phoneButton = "_nx-0";